module.exports = __webpack_public_path__ + "static/media/invite_details_arrow_closed_over.986a3226.svg";